import { forwardRef, type Ref, type SVGProps } from "react";
const IconISOFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M20.26 12.34a1.58 1.58 0 0 0-1.32.57 2.8 2.8 0 0 0-.44 1.7 2.76 2.76 0 0 0 .44 1.7 1.55 1.55 0 0 0 1.31.57c1.16 0 1.74-.75 1.74-2.27s-.58-2.27-1.73-2.27"
    />
    <path
      fill="currentColor"
      d="M29 5H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1M10.25 18H8.79v-6.74h1.46zm5.11-.43a2.94 2.94 0 0 1-1.86.52 4.3 4.3 0 0 1-1.95-.41v-1.33q.574.258 1.18.43.433.114.88.12c.26.017.517-.046.74-.18a.61.61 0 0 0 .25-.53.54.54 0 0 0-.11-.35 1.1 1.1 0 0 0-.33-.3 8 8 0 0 0-.89-.46 4.5 4.5 0 0 1-.95-.55 2 2 0 0 1-.5-.63 1.66 1.66 0 0 1-.19-.82 1.74 1.74 0 0 1 .62-1.41 2.6 2.6 0 0 1 1.75-.51 3.8 3.8 0 0 1 1 .13q.514.135 1 .35l-.47 1.1a7 7 0 0 0-.91-.3 3 3 0 0 0-.71-.09.9.9 0 0 0-.63.19.6.6 0 0 0-.22.49.6.6 0 0 0 .09.33 1 1 0 0 0 .28.27q.444.266.92.47c.504.199.955.51 1.32.91a1.89 1.89 0 0 1-.31 2.55zm7.31-.38a3.15 3.15 0 0 1-2.42.9 3.16 3.16 0 0 1-2.43-.9A3.63 3.63 0 0 1 17 14.6a3.58 3.58 0 0 1 .82-2.6 3.23 3.23 0 0 1 2.44-.89 3.15 3.15 0 0 1 2.42.9 3.6 3.6 0 0 1 .84 2.56 3.57 3.57 0 0 1-.85 2.61z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconISOFilledSVG);
ForwardRef.displayName = "IconISOFilled";
export { ForwardRef as IconISOFilled };
